import styled from 'styled-components'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import CancelIcon from '@mui/icons-material/Cancel'
import { Drawer } from '@mui/material'
import React from 'react'
import { useState } from 'react'
import ReactSpeedometer from 'react-d3-speedometer'
import { GenericDisplayFlexColumn } from 'src/mentor/layout/Styles'
import { assessmentResultColors } from 'src/consumer/constants'
import parse from 'html-react-parser'
import { styled as muiStyled } from '@mui/material'
import { ButtonBase } from '@mui/material'

export const AssessmentPlayerBackground = styled.div`
  width: 100%;
  height: 100vh;
  background: #fff;
  font-family: Outfit;
  display: flex;
  justify-content: ${(props) => (props?.centerVertically ? 'center' : 'flex-start')};
  padding: ${(props) => (props?.noBottomPadding ? '100px 30px 0' : '100px 30px')};
  flex-direction: column;
  position: relative;
  ${(props) => props?.noPadding && 'padding: 0'};
`

export const AssessmentPlayerHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  height: 50px;
`

// Bumped from 7px to 10px and the track to a slightly deeper grey
// (slate-200 territory) so the bar reads as a deliberate progress
// affordance instead of a hairline. Width unchanged — it's already
// container-relative. The fill keeps the original AUMHUM purple but
// gets a soft gradient so the front edge feels like motion.
export const AssessmentProgressBarContainer = styled.div`
  border-radius: 999px;
  background: #e2e8f0;
  height: 10px;
  width: 60%;
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.06);
  @media (min-width: 768px) {
    width: 70%;
  }
`

export const AssessmentProgressBarFilled = styled.div`
  position: absolute;
  background: linear-gradient(90deg, #7c3aed 0%, #9f68da 100%);
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 999px;
  width: ${(props) => `${props?.progress}%`};
  transition: width 0.4s ease-in-out;
  /* Subtle highlight on the right edge so progress reads as
     "moving forward" rather than a static fill. */
  box-shadow: 0 0 0 1px rgba(124, 58, 237, 0.10);
`

export const AssessmentBackButton = styled(KeyboardBackspaceIcon)`
  position: absolute;
  left: 20px;
  cursor: pointer;
`

////////////////////////////////////////////////////////////
// for interaction pages:

export const AssessmentPlayerSecondHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  position: absolute;
  top: 50px;
  height: 50px;
  padding: 0 25%;
  @media (min-width: 768px) {
    padding: 0 15%;
  }
`

export const AssessmentPlayerQuestionSuperText = styled.div`
  color: #0d9488;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.44px;
  @media (min-width: 768px) {
    font-size: 14px;
    letter-spacing: 1.92px;
  }
`

export const AssessmentPlayerQuestionNumber = styled.span`
  color: ${(props) => (props?.main ? '#22BA2A' : '#B0B0B0')};
  font-size: ${(props) => (props?.main ? '29px' : '15px')};
  font-weight: 700;
  @media (min-width: 768px) {
    font-size: ${(props) => (props?.main ? '39px' : '23px')};
  }
`

export const AssessmentPlayerInteractionPageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: ${(props) => (props?.noBottomPadding ? '0' : '70px')};
  position: relative;
`

export const AssessmentPlayerQuestion = styled.div`
    color: #1E1F23;
    font-size: 25px;
    font-weight: 500;
    margin: 40px 0 20px;
    width: 90%;
    text-align: center;
    ${(props) => !props?.textLeftNoMinHeight && 'min-height: 120px;'};
    ${(props) => props?.textLeftNoMinHeight && 'text-align: left;'};
    flex-shrink: 0;
    @media (min-width: 768px) {
        width: 70%;
        font-size: 25px;
        font-weight: 500;
        margin: 40px auto 20px;
    }
    @media (min-width: 1024px) {
        font-size: 25px;
        font-weight: 500;
    }
    @media (min-width: 1512px) {
        margin: 40px auto 20px;
    }
`

export const AssessmentPlayerQuestionSubText = styled.div`
    color: #475569;
    font-size: 14px;
    line-height: 1.5;
    margin: 8px 0 16px;
    width: 90%;
    text-align: center;
    padding: 10px 12px;
    background: #f1f5f9;
    border-left: 4px solid #0ea5e9;
    border-radius: 6px;
    @media (min-width: 768px) {
        width: 70%;
    }
`

export const AssessmentSelectOptionBox = muiStyled(ButtonBase)(
  ({ theme }) => `
    display: flex;
    text-align: left;
    align-items: center;
    border: 1px solid #D8D8EC;
    width: 100%;
    max-width: 600px;
    color: #37383D;
    font-size: 17px;
    font-weight: 300;
    border-radius: 11px;
    padding: 9px 60px 9px 25px;
    margin-bottom: 15px;
    position: relative;
    @media (min-width: 768px) {
        font-size: 20px;
        margin-bottom: 19px;
    }
    &:hover {
        border: 1px solid #797983;
    }`,
)

export const AssessmentSelectOptonDot = styled.div`
  width: 21px;
  height: 21px;
  border-radius: ${(props) => (props?.square ? '3px' : '50%')};
  flex-shrink: 0;
  background: ${(props) => (props?.selected ? '#22ba2a' : '#D8D8EC')};
  position: absolute;
  right: 15px;
`

export const AssessmentSelectOptonMultipleIcon = styled.img`
  width: 21px;
  height: 21px;
  border-radius: 3px;
  flex-shrink: 0;
  position: absolute;
  right: 15px;
`

export const AssessmentInputTextContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 400px;
  padding: 70px 20px;
  border: none;
  outline: none;
  resize: none;
  font-size: 15px;
  cursor: default;
  font-weight: 600;
  border-radius: 35px 35px 0px 0px;
  background: #e9e2ff;
  box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.14);
  color: #000;
  font-size: 16px;
  font-weight: 400;
  position: relative;
  @media (min-width: 768px) {
    width: calc(70% + 42px);
    font-size: 19px;
  }
`

export const AssessmentInputTextArea = styled.textarea`
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: #e9e2ff;
  resize: none;
  :: -webkit-scrollbar {
    width: 5px;
  }
  :: -webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
  }
  :: -webkit-scrollbar-thumb {
    background: #67438d;
    border-radius: 5px;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  // Hide scrollbar for IE, Edge and Firefox
`

export const AssessmentContinueButton = styled.button`
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  border-radius: 24px;
  background: #9f68da;
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-transform: uppercase;
  width: 150px;
  padding: 7px 18px;
  @media (min-width: 768px) {
    font-size: 19px;
  }
  &:disabled {
    background: #aaa;
    color: #fff;
  }
`

export const AssessmentComparativeQuestionContainer = styled.div`
  width: 100%;
  margin-bottom: 50px;
  display: grid;
  grid-template-columns: 3fr 1fr 3fr; /* Three columns with different sizes */
  color: #505154;
  font-weight: 300;
  @media (min-width: 768px) {
    font-size: 21px;
  }
`

export const ACQuestionItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 20px;
  min-height: 100px;
  @media (min-width: 768px) {
    min-height: 200px;
  }
`

export const ACQuestionItemSeparator = styled.div`
  height: 100%;
  width: 1.5px;
  border-radius: 1px;
  background: #d9d9d9;
`

export const ACQComparativeAndSliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  @media (min-width: 768px) {
    width: 70%;
  }
`

////////////////////////////////////////////////////////////
// for information pages:

export const AssessmentPlayerInformationPageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

export const AssessmentPlayerInformationPagePicture = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
  object-fit: cover;
  object-position: center;
  margin-bottom: 30px;
  @media (min-width: 768px) {
    width: 125px;
    height: 125px;
  }
`

export const AssessmentPlayerInformationPageTitle = styled.div`
    color: #363636;
    font-size: 26px;
    font-weight: 700;
    margin-bottom: 15px;
    text-align: center;
    width: 100%;
    @media  (min-width: 768px) {
        width: 75%;
        font-size: 35px;
    } 
    @media (min-width: 1280px) {
        width: 50%;
    }
}
`

export const AssessmentPlayerInformationPageDescription = styled.div`
    color: #363636;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 30px;
    @media  (min-width: 768px) {
        width: 75%;
    } 
    @media (min-width: 1280px) {
        width: 50%;
    }
}
`

export const AssessmentPlayerInformationPageActionButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  margin: 25px auto 0;
  color: #fff;
  height: 50px;
  min-height: 50px;
  background: #006a61;
  font-size: 17px;
  border-radius: 10px;
  padding: 0 10px;
  transition: all 200ms ease-in-out 0s;
`

export const AssessmentPlayerExtraLink = styled.div`
  text-align: center;
  color: #596e92;
  font-size: 14px;
  margin: 2px auto;
  cursor: ${(props) => (props?.link ? 'pointer' : 'default')};
`

export const AssessmentPlayerFooterText = styled.div`
  position: absolute;
  bottom: 20px;
  text-align: center;
  color: #596e92;
  font-size: 14px;
`

////////////////////////////////////////////////////////////
// for result page :

export const AssessmentPlayerResultPageContainer = styled.div`
  position: relative;
  font-family: Outfit;
  width: 100%;
  min-height: 100vh;
  height: auto;
  display: flex;
  align-items: center;
  padding: 50px 50px 150px;
  flex-direction: column;
`

export const AssessmentPlayerResultPageMainPartContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 60px;
  flex-shrink: 0;
  width: 100%;
  height: auto;
  margin: auto 0;
  position: relative;
`

export const AssessmentPlayerResultPageSecondaryPartContainer = styled.div`
  transition: all 0.2s ease-in-out;
  width: 100%;
  height: auto;
  color: #fff;
  text-align: center;
  padding: 21px 50px;

  @media (min-width: 768px) {
    padding: 50px 70px;
    width: 50%;
    height: 100%;
  }
`

export const AssessmentPlayerResultButtonsContainer = styled.div`
  position: fixed;
  bottom: 20px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  @media (min-width: 768px) {
    gap: 10px;
  }
`

export const AssessmentPlayerResultUnderlinedText = styled.button`
  font-size: 12px;
  color: #313131;
  text-decoration: underline;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`

export const AssessmentPlayerResultButton = styled.button`
  background: ${(props) => (props?.preferred ? '#298D5B' : '#FFF')};
  color: ${(props) => (props?.preferred ? '#FFF' : '#298D5B')};
  border-radius: 36px;
  padding: 7px 25px;
  font-size: 12px;
  font-weight: ${(props) => (props?.preferred ? '700' : '400')};
  border: 1px solid #298d5b;
  width: 100%;
  transition: all 0.3s ease-in-out;
  @media (min-width: 568px) {
    padding: 12px 34px;
    font-size: 16px;
    width: auto;
  }
  &:hover {
    background: #2C302E;
    border: 1px solid #000;
  }
  &:active {
    scale: 0.9;
  }
`

export const AssessmentPlayerResultCloseButton = styled(CancelIcon)`
  width: 35px;
  height: 35px;
  position: fixed;
  top: 15px;
  left: 15px;
  cursor: pointer;
  margin: 0;
  padding: 0;
  @media (min-width: 768px) {
    top: 25px;
    left: 25px;
  }
`

export const AssessmentPlayerChartTitleSpan = styled.span`
  color: #5b3585;
  font-size: 14px;
  font-weight: 500;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`

export const AssessmentPlayerChartDescriptionSpan = styled.span`
  color: ${(props) => (props?.detailedReportText ? '#0029FF' : '#707070')};
  max-width: 400px;
  text-align: center;
  font-size: 14px;
  line-height: 17px;
  margin: 10px 0;
  font-weight: ${(props) => (props?.detailedReportText ? '600' : '300')};
  @media (min-width: 768px) {
    line-height: 19px;
    font-weight: ${(props) => (props?.detailedReportText ? '600' : '300')};
  }
`

export const DetailedReportDrawer = styled(Drawer)`
  display: flex;
  justify-content: center;
  // backdrop-filter: blur(1px);
  background-color: rgba(106, 109, 210, 0.2);
  .MuiPaper-root {
    height: 90vh;
    width: 100%;
    left: auto;
    right: auto;
    background: #ffffff;
    background-size: 100% 100%;
    border-radius: 25px 25px 0px 0px;
    padding: 75px 0;
    ::-webkit-scrollbar {
      display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  @media (min-width: 768px) {
    .MuiPaper-root {
      width: 80%;
      padding: 75px 0;
    }
  }
`

export const DetailedReportContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-family: Outfit;
  align-items: center;
  padding: 0 25px;
`

export const DetailedReportTitle = styled.div`
  color: #000;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1.92px;
  width: 100%;
  text-align: left;
  @media (min-width: 768px) {
    font-size: 21px;
    font-weight: 700;
    letter-spacing: 3px;
  }
`

export const DetailedReportTabChangeContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  overflow: auto;
  gap: 10px;
  flex-shrink: 0;
  margin-bottom: 15px;
  ::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

export const DetailedReportTabChangeButton = styled.button`
  color: ${(props) => (props?.selected ? '#FFF' : '#9A9A9A')};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  font-size: 16px;
  font-weight: 600;
  border-radius: 23px;
  padding: 9px 25px;
  background: ${(props) => (props?.selected ? '#9F68DA' : '#EBEBEB')};
  @media (min-width: 768px) {
    font-size: 16px;
    padding: 12px 28px;
  }
`

export const DetailedReportDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  @media (min-width: 1280px) {
    flex-direction: row;
    gap: 150px;
    padding: 0 75px;
    align-items: flex-start;
  }
`

export const DetailedReportDataArticleContainer = styled.div`
  color: #000;
  @media (min-width: 1080px) {
  }
`

export const SpeedometerContainer = styled.div`
  width: 250px;
  min-height: 150px;
  margin-top: 40px;
  flex-shrink: 0;
  position: relative;
  transform: ${(props) => props?.scale && 'scale(0.7)'};
`

export const LabelsContainer = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  bottom: 0;
  left: 0;
  margin: 0 auto;
  right: 0;
`

export const LabelItem = styled.div`
  width: 2px;
  height: 2px;
  border: 1px solid red;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  bottom: ${(props) => `${props?.bottom}px`};
  right: ${(props) => `${props?.right}px`};
`

export const LabelItemName = styled.div`
  font-size: 12px;
  display: flex;
  justify-content: center;
  font-weight: 500;
  text-align: center;
  ${(props) => props?.nowrap && `white-space: nowrap;`};
`

export const ResultRangeName = styled.div`
  font-size: 28px;
  display: flex;
  justify-content: center;
  font-weight: 500;
  text-align: center;
  ${(props) => props?.colorValue && `color: ${props?.colorValue};`};
`

////////////////////////////////////////////////////////////
// components

export const SpeedometerComponent = ({
  resultItem,
  indexResultItem = 0,
  scoringRangeItem,
  labelTextWhite = false,
  scale = 1,
}) => {
  const lengthOfScoringRange = resultItem?.scoringRangeList?.length
  const minValueOfScoringRange = resultItem?.scoringRangeList?.[0]?.min
  const maxValueOfScoringRange = resultItem?.scoringRangeList?.[lengthOfScoringRange - 1]?.max
  let userScoreValue
  if (resultItem?.userScore <= maxValueOfScoringRange) {
    userScoreValue = resultItem?.userScore
  } else {
    userScoreValue = maxValueOfScoringRange
  }

  const makeCustomSegmentStops = () => {
    const tempArray = []
    tempArray?.push(minValueOfScoringRange)
    resultItem?.scoringRangeList?.forEach((item) => {
      tempArray?.push(item?.max)
    })
    return tempArray
  }

  const makeCustomSegmentLabelsArray = () => {
    const tempArray = []
    resultItem?.scoringRangeList?.forEach((item) => {
      tempArray?.push({
        rangeText: `${item?.min}-${item?.max}`,
        text: item?.title,
        color: assessmentResultColors?.[indexResultItem]?.endColor,
      })
    })
    return tempArray
  }

  const customSegmentStops = makeCustomSegmentStops()
  const customSegmentLabels = makeCustomSegmentLabelsArray()

  const makeCustomSegmentLabelPositions = () => {
    const tempArray = []
    customSegmentStops?.forEach((item, index) => {
      if (index < customSegmentStops?.length - 1) {
        const halfwayStop = (item + customSegmentStops?.[index + 1]) / 2
        tempArray.push(halfwayStop / customSegmentStops?.[customSegmentStops?.length - 1])
      }
    })
    const radius = 180
    const tempArrayTwo = []
    tempArray?.forEach((item, index) => {
      const base = radius * Math.cos(item * Math.PI)
      const perpendicular = radius * Math.sin(item * Math.PI)
      tempArrayTwo?.push({ bottom: perpendicular, right: base })
    })
    return tempArrayTwo
  }
  const customSegmentLabelPositions = makeCustomSegmentLabelPositions()

  console.log(scoringRangeItem)

  return (
    <SpeedometerContainer scale={scale}>
      <ReactSpeedometer
        customSegmentStops={customSegmentStops}
        fluidWidth={true}
        value={userScoreValue}
        // maxSegmentLabels={0}
        minValue={minValueOfScoringRange}
        maxValue={maxValueOfScoringRange}
        needleColor="black"
        startColor={assessmentResultColors?.[indexResultItem]?.startColor}
        endColor={assessmentResultColors?.[indexResultItem]?.endColor}
        segments={lengthOfScoringRange}
        needleHeightRatio={0.7}
        ringWidth={30}
        // forceRender={true}
        needleTransitionDuration={3333}
        needleTransition="easeExpOut"
        textColor="#4c4c4c"
      />
      <ResultRangeName colorValue={assessmentResultColors?.[indexResultItem]?.endColor}>
        {scoringRangeItem?.title}
      </ResultRangeName>
      {/* {customSegmentLabels?.map((item, index) => (
                <LabelsContainer key={index}>
                    <LabelItem
                        bottom={customSegmentLabelPositions?.[index]?.bottom}
                        right={customSegmentLabelPositions?.[index]?.right}
                    >
                        <>
                            <LabelItemName nowrap={true} style={{ color: labelTextWhite ? '#FFF' : customSegmentLabels?.[index]?.color }}>{customSegmentLabels?.[index]?.rangeText}</LabelItemName>
                            <LabelItemName style={{ color: labelTextWhite ? '#FFF' : customSegmentLabels?.[index]?.color }}>{customSegmentLabels?.[index]?.text}</LabelItemName>
                        </>
                    </LabelItem>
                </LabelsContainer>
            ))} */}
      {/* this whole label related thing is a trigonometric attempt to show ranges */}
    </SpeedometerContainer>
  )
}

export const DetailedReportComponent = ({ title, detailedReportData, resultsData, tabId }) => {
  const [selectedTabId, setSelectedTabId] = useState(tabId || resultsData?.[0]?.domainId)

  const selectedIdResultData = resultsData?.find((item) => item?.domainId === selectedTabId)
  const selectedIdArticleData = detailedReportData?.find((item) => item?.domain === selectedTabId)

  const scoringRangeItem = selectedIdResultData?.scoringRangeList?.find(
    (item) =>
      item?.min <= selectedIdResultData?.userScore && item?.max >= selectedIdResultData?.userScore,
  )

  return (
    <DetailedReportContainer>
      <DetailedReportTitle>{title}</DetailedReportTitle>
      <DetailedReportTabChangeContainer>
        {resultsData?.map((resultItem, index) => (
          <DetailedReportTabChangeButton
            key={index}
            selected={selectedTabId === resultItem?.domainId}
            onClick={() => setSelectedTabId(resultItem?.domainId)}
          >
            {resultItem?.domainName}
          </DetailedReportTabChangeButton>
        ))}
      </DetailedReportTabChangeContainer>
      <DetailedReportDataContainer>
        <GenericDisplayFlexColumn aic>
          <SpeedometerComponent
            resultItem={resultsData?.find((item) => item?.domainId === selectedTabId)}
            scoringRangeItem={scoringRangeItem}
          />
          <div style={{ textAlign: 'center' }}>
            <AssessmentPlayerChartTitleSpan
              text
              color={'#7c3aed'}
            >{`Your ${selectedIdResultData?.domainName} score is `}</AssessmentPlayerChartTitleSpan>
            <AssessmentPlayerChartTitleSpan>{`${selectedIdResultData?.userScore}/${selectedIdResultData?.totalScore}`}</AssessmentPlayerChartTitleSpan>
          </div>
        </GenericDisplayFlexColumn>
        <DetailedReportDataArticleContainer>
          {selectedIdArticleData?.articleData?.content &&
            parse(selectedIdArticleData?.articleData?.content)}
        </DetailedReportDataArticleContainer>
      </DetailedReportDataContainer>
    </DetailedReportContainer>
  )
}

export const GoBackToPageWhereYouCameFromButton = muiStyled(ButtonBase)(
  ({ theme }) => `
display: flex;
justify-content: flex-start;
align-items:center;
align-self: start;
margin: 0px 0px 10px 5px;
border-radius: 7px;
padding: 5px 10px;
`,
)
